"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  canvasContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
    '& canvas': {
      backgroundColor: '#fff'
    },
    '& .canvasPlaceholder > canvas': {
      margin: 'auto'
    }
  }
};